import { supabase } from "./supabaseClient";

export function saveUserPreference(key: string, value: string | boolean): void {
  if (!supabase) return;
  supabase.auth.updateUser({ data: { [key]: value } }).catch(() => {});
}
